import { FileData } from './files'
import { ID, UpdateData } from '../types/UtilityTypes'
import { User } from './users'
import { HistoryType } from '../constants/enums'

export interface CommentData {
    ref?: Comment | null,
    text?: string | null,
    files?: FileData[],
    resulted?: boolean,
}

export type CommentRequestData = Omit<UpdateData<CommentData>, 'id'>

export interface Comment {
    id: ID,
    ref?: Comment | null,
    owner_type: HistoryType,
    owner_id: ID,
    user_id: ID,
    created_at: string,
    user?: User,
    text: string,
    edited: boolean,
    deleted: boolean,
    resulted: boolean,
    files: FileData[],
}